import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import { InfoTooltip, Stack, tokens, Typography } from '@cast/design-system';
import { DATE_MONTH_DAY_TIME } from '@cast/constants';

import { useInventoryWorkloadsTimeRangeSelection } from '../../../_hooks/useInventoryWorkloadsTimeRangeSelection';

dayjs.extend(utc);
dayjs.extend(timezone);

const SNAPSHOT_DATE_TOOLTIP =
  'The widget reflects the latest snapshot, not the selected time range';

export type CardCurrentDateArgs = Record<string, never>;

export const CardCurrentDate = (_: CardCurrentDateArgs) => {
  const { timeZone } = useInventoryWorkloadsTimeRangeSelection();
  const currentDate = dayjs().tz(timeZone).format(DATE_MONTH_DAY_TIME);

  return (
    <Stack direction="row" alignItems="center" gap={4}>
      <Typography
        variant="P12R"
        color={tokens.theme.fg.structural.secondary}
        data-testid="card-current-date"
      >
        {currentDate}
      </Typography>
      <InfoTooltip
        title={SNAPSHOT_DATE_TOOLTIP}
        iconSize={14}
        color={tokens.theme.fg.structural.secondary}
      />
    </Stack>
  );
};
